import { useNavigate } from "react-router-dom";
import { KycApproveIcon } from "../../../../assets/icons/svgicons";
import { ROUTES } from "../../../../routes";
import Button from "../../Button/Button";
import Modal from "../Modal/Modal";
import styles from "../ThanksModal/ThanksModal.module.scss";

const ApplicationSuccessModal = ({ show, handleClose }) => {
  const navigate = useNavigate();

  return (
    <Modal
      className={styles.thanks_modal}
      show={show}
      handleClose={handleClose}
      title={true}
    >
      <div className={styles.direct_sec}>
        <div className={styles.deposit_img}>
          <KycApproveIcon />
        </div>
        <h2 className="smallText">Application Successful</h2>
        <p>You will be notified after successful verification</p>
      </div>
      <Button
        fluid
        className={styles.submit_btn}
        onClick={() => navigate(ROUTES.APPLY_CARD)}
      >
        Done
      </Button>
    </Modal>
  );
};

export default ApplicationSuccessModal;
